<div class="rounded-md border border-slate-700 bg-slate-800/40 p-2">
  <div class="mb-1 text-xs font-semibold text-slate-200">{{ view().title || 'Alerts' }}</div>
  @if (view().rows.length === 0) {
    <div class="text-xs text-slate-400">No alerts provided.</div>
  } @else {
    <ul class="space-y-1">
      @for (a of view().rows; track $index) {
        <li class="flex items-start gap-2 text-xs">
          <span class="mt-0.5 shrink-0 rounded px-1.5 py-0.5 text-2xs font-semibold uppercase" [class]="a.badgeClass">
            {{ a.severity }}
          </span>
          <span class="text-slate-200">
            {{ a.message }}
            @if (a.timestamp !== '—') {
              <span class="text-slate-500"> · {{ a.timestamp }}</span>
            }
          </span>
        </li>
      }
    </ul>
  }
</div>
